import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { sendStaffAppMetaData } from "../../eventTriggers";

export const Documents = () => {
  const { documents, organization, resident, config } = useSelector(
    (state) => state
  );

  function handleClick(e) {
    sendStaffAppMetaData({
      hLabel: 'Document',
      lbbUri: `${config.root_url}organizations/${organization.name}/residents/${resident.id}#documents`
    })
  }

  return (
    <div>
      {documents.map((document) => (
        <a
          key={document.id}
          onClick={(_) => handleClick(document)}
          className="p-4 border-bottom clickable d-block text-black"
          href={document.asset_url}
        >
          <b>{document.name}</b>
          <div>{moment(document.created_at).format("MM/DD/YYYY hh:mma")}</div>
        </a>
      ))}
    </div>
  );
};
